'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DocumentIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DocumentIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.4999 1.5C22.4999 1.23478 22.406 0.98043 22.2389 0.792893C22.0717 0.605357 21.845 0.5 21.6086 0.5H5.56513C5.32874 0.5 5.10204 0.605357 4.93489 0.792893C4.76773 0.98043 4.67383 1.23478 4.67383 1.5V19.5C4.67383 19.7652 4.76773 20.0196 4.93489 20.2071C5.10204 20.3946 5.32874 20.5 5.56513 20.5H21.6086C21.845 20.5 22.0717 20.3946 22.2389 20.2071C22.406 20.0196 22.4999 19.7652 22.4999 19.5V1.5Z"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2356 4.49707H18.9312"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2356 8.49707H18.9312"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2356 12.4971H18.9312"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2356 16.4971H13.1413"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.67391 4.5H2.8913C2.65492 4.5 2.42821 4.60536 2.26106 4.79289C2.09391 4.98043 2 5.23478 2 5.5V22.5C2 22.7652 2.09391 23.0196 2.26106 23.2071C2.42821 23.3946 2.65492 23.5 2.8913 23.5H18.0435C18.2799 23.5 18.5066 23.3946 18.6737 23.2071C18.8409 23.0196 18.9348 22.7652 18.9348 22.5V20.5"
          stroke={sx?.color || '#3D517B'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

DocumentIcon.propTypes = {
  sx: PropTypes.object
}
